import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import I18nContext from '../../contexts/i18n';
import L from '../common/localized';

const GooglePrivacyPolicyLink = (props) => (
  <a target='_blank' rel='noopener noreferrer' href='https://policies.google.com/privacy'>
    {props.content}
  </a>);

const GoogleTermsOfServiceLink = (props) => (
  <a target='_blank' rel='noopener noreferrer' href='https://policies.google.com/terms'>
    {props.content}
  </a>);

const GoogleRecaptchaBranding = (props) => {
  const i18nSettings = useContext(I18nContext);

  const isRTL = i18nSettings.isLocaleRTL();
  const changeApplyStructureToArabic = <L text='Google Company&apos;s' />;

  return (
    <GoogleRecaptchaBrandingWrapper width={props.width} squeezeToTop={props.squeezeToTop} white={props.white}
      textAlign={props.textAlign}>
      <L text='web.google_recaptcha_branding.site_protection_text' isToken />&nbsp;
      <GooglePrivacyPolicyLink content={<L text='web.google_recaptcha_branding.privacy_policy_text'
      isToken />} />
      <L text='web.google_recaptcha_branding.and_text' isToken />&nbsp;
      <GoogleTermsOfServiceLink content={<L text='web.google_recaptcha_branding.terms_of_service_text'
      isToken />} />
        {isRTL ? changeApplyStructureToArabic : ' apply'}.
    </GoogleRecaptchaBrandingWrapper>
  );
};

const GoogleRecaptchaBrandingWrapper = styled.div`
  width: ${props => props.width ? props.width : '100%'};
  font-size: 0.75em;
  color: ${props => props.white ? '#e0e0e0' : '#7f7f7f'};
  padding: '6px 4px 4px 4px';
  padding-top: ${props => props.squeezeToTop ? '0' : '4px'};
  margin-top: ${props => props.squeezeToTop ? '-4px' : '0'};
  margin-bottom: ${props => props.squeezeToTop ? '20px' : '0'};
  line-height: 1;
  text-align: ${props => props.textAlign ? props.textAlign : 'left'};
`;

if (process.env.NODE_ENV !== 'production') {
  GoogleRecaptchaBranding.propTypes = {
    width: PropTypes.string,
    white: PropTypes.bool,
    squeezeToTop: PropTypes.bool,
    textAlign: PropTypes.string
  };
}

GoogleRecaptchaBranding.defaultProps = {
  width: 'auto',
  white: false,
  squeezeToTop: false
};

export default GoogleRecaptchaBranding;
